import React, {createContext, useEffect, useState} from "react";
import {DeviceType} from "./device-context-vars";

interface DeviceContextProps {
    children: React.ReactNode,
}

export interface DeviceContextState {
    deviceType: DeviceType;
}

export const DeviceContext = createContext<DeviceContextState>({
    deviceType: DeviceType.DESKTOP
});

function DeviceContextProvider(props: DeviceContextProps) {

    const [device, setDevice] = useState<DeviceContextState>({
        deviceType: DeviceType.DESKTOP});

    useEffect(() => {
        checkDeviceType();
        window.addEventListener('resize', checkDeviceType);
        return () => window.removeEventListener('resize', checkDeviceType);
    }, [])

    const checkDeviceType = () => {
        const width = window.innerWidth;
        if (width < 768) {
            setDevice({
                deviceType: DeviceType.MOBILE
            });
        } else if (width >= 768 && width < 1024) {
            setDevice({
                deviceType: DeviceType.TABLET
            });
        } else {
            setDevice({
                deviceType: DeviceType.DESKTOP
            });
        }
    };

    return (
        <DeviceContext.Provider value={device}>
            {props.children}
        </DeviceContext.Provider>
    );

}

export default DeviceContextProvider;